import React, {useRef} from 'react';
import {Button, Dropdown} from 'react-bootstrap';
import ArrowClockwise from '@mui/icons-material/AutorenewRounded';
import InfoCircle from '@mui/icons-material/InfoRounded';
import CustomRangeModal from './modals/CustomRangeModal';
import {useStatisticsUI, useTimeRange} from '../context/StatisticsContext';

const TimeRangeSelector = ({helpLink}) => {
  const {range, rangeLabels, updateRelativeRange} = useTimeRange();
  const {activeTab} = useStatisticsUI();
  const showCustomRangeModal = useRef(null);

  return (
    <div className="row align-items-center mb-3">
      <div className="col-8 col-md-3 d-flex align-items-center gap-2">
        <Button variant="" onClick={() => updateRelativeRange(range)}>
          <ArrowClockwise/>
        </Button>

        <Dropdown>
          <Dropdown.Toggle variant="" id="dropdown-range">
            <span>{rangeLabels[range] || range}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => updateRelativeRange('1h')}>Last hour</Dropdown.Item>
            <Dropdown.Item onClick={() => updateRelativeRange('1d')}>Today</Dropdown.Item>
            <Dropdown.Item onClick={() => updateRelativeRange('7d')}>This Week</Dropdown.Item>
            <Dropdown.Item onClick={() => updateRelativeRange('30d')}>This Month</Dropdown.Item>
            <Dropdown.Divider/>
            <Dropdown.Item onClick={() => showCustomRangeModal.current?.()}>
              Custom Range
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <CustomRangeModal onShow={(showFunc) => (showCustomRangeModal.current = showFunc)}/>
      </div>

      <div className="col-md-6 text-center d-none d-md-block">
        <p className="mb-0">{activeTab}</p>
      </div>

      <div className="col-4 col-md-3 text-end">
        {helpLink && (
          <a href={helpLink} target="_blank" rel="noopener noreferrer">
            <InfoCircle size={20}/>
          </a>
        )}
      </div>
    </div>
  );
};

export default TimeRangeSelector;
